import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Me, UpdateUser } from "../api/users";
import { RestaurantGet, GetRestaurants } from "../api/restaurant";
import { PostGet } from "../api/post";

const Header = ({ isAuthenticated, userAccessLevel, token }) => {
  const [rest, setRest] = useState("");
  const [restaurants, setRestaurants] = useState([]);
  const [modalMessage, setModalMessage] = useState("");
  const [allRestaurants, setAllRestaurants] = useState();
  const [userRestaurant, setUserRestaurant] = useState("");
  const [selectedRestaurant, setSelectedRestaurant] = useState(0);
  const [fetchData, setFetchData] = useState({
    user: null,
    restaurant: null,
  });

  const fetchFields = async () => {
    try {
      if (userAccessLevel >= 13) {
        const I = await Me(token);
        const rest = await RestaurantGet(token, I.restaurant_id);
        setRest(rest.name);
        const restaurants = await GetRestaurants(token, 1, 50);

        setRestaurants(restaurants.data);
        setAllRestaurants(restaurants);
        setSelectedRestaurant(rest.id);
        setFetchData({
          user: I,
          restaurant: rest.id,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchFields();
  }, [token]);

  async function changeRestaurant() {
    if (selectedRestaurant == 0) {
      setModalMessage(
        <p style={{ color: "red", marginTop: "3%" }}>
          Нельзя выбрать такой Ресторан :)
        </p>
      );
      return;
    }
    const data = await UpdateUser(token, {
      id: fetchData.user.id,
      restaurant_id: selectedRestaurant,
    });
    if (data.detail) {
      setModalMessage(
        <p style={{ color: "red", marginTop: "3%" }}>{data.detail} </p>
      );
    } else {
      setModalMessage(
        <p style={{ color: "green", marginTop: "3%" }}> Успешно!</p>
      );
    }
    console.log(allRestaurants);
    for (let rest of allRestaurants.data) {
      if (rest.id == selectedRestaurant) {
        setRest(rest.name);
      }
    }
  }

  return (
    <header
      style={{
        padding: "1rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Link to="/" style={{ textDecoration: "none", marginLeft: "5%" }}>
        <h1 style={{ fontWeight: "bolder" }}>Sсhedule </h1>
      </Link>

      {/* {isAuthenticated && (
        <nav>
          <Link to="/profile" style={{ color: "white", marginLeft: "1rem" }}>
            Профиль
          </Link>
        </nav>
      )} */}
      {userAccessLevel > 13 && (
        <p
          data-bs-toggle="modal"
          data-bs-target="#staticBackdropChangeRest"
          style={{ marginRight: "5%", fontSize: "18px" }}
        >
          Ресторан: {rest}
        </p>
      )}
      <div
        className="modal fade"
        id="staticBackdropChangeRest"
        tabIndex="5"
        aria-labelledby="staticBackdropLabelChangeRest"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5
                className="modal-title text-center"
                id="staticBackdropLabelChangeRest"
              >
                Информация
              </h5>
            </div>
            <div className="modal-body text-center">
              <select
                className="form-select"
                aria-label="Default select example"
                value={selectedRestaurant}
                onChange={(e) => setSelectedRestaurant(e.target.value)}
              >
                <option value={0}>Выберите Ресторан</option>
                {restaurants.map((rest) => (
                  <option key={rest.id} value={rest.id}>
                    {rest.name}
                  </option>
                ))}
              </select>
              <button
                className="btn"
                onClick={changeRestaurant}
                style={{ marginTop: "5%" }}
              >
                Сохранить
              </button>
              {modalMessage}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
